import React, {useEffect, useRef, useState} from "react";
import arrayShuffle from 'array-shuffle';
import {useDrag, useDrop} from "react-dnd";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

interface PuzzleDragObject {
    id: number
    position: number
}

const PuzzleDragObjectType = 'puzzle-drag-item'

const PuzzleDragItem = ( { id, position, onDragEnd, src, disabled } ) => {
    const ref = useRef(null);

    const [{ isDragging }, connectDrag] = useDrag({
        item: { id: id, position: position },
        type: PuzzleDragObjectType,
        canDrag: disabled !== true,
        collect: monitor => {
            return {
                isDragging: monitor.isDragging()
            };
        }
    })

    const [, connectDrop] = useDrop({
        accept: PuzzleDragObjectType,
        drop(dragObject) {
            const item = dragObject as PuzzleDragObject
            if (item.id !== id) {
                onDragEnd(id, item.id)
            }
        },
    })

    connectDrag(ref)
    connectDrop(ref)

    const opacity = isDragging ? 0.3 : 1
    const left = (position % 3) * 33.33
    const top = Math.floor(position / 3) * 33.33
    const backgroundX = 50 * (id.id % 3)
    const backgroundY = 50 * Math.floor(id.id / 3)

    return <div ref={ref} className="puzzle-item" style={{
        backgroundImage: "url(" + src + ")",
        backgroundPositionX: backgroundX + "% ",
        backgroundPositionY: backgroundY + "%",
        top: top + "%",
        left: left + "%",
        opacity: opacity
    }}></div>
}

export default function Puzzle(props : { imageSource: string, solve: boolean, onComplete: () => void }) {

    const [isCompleted, setIsCompleted] = useState(false)
    const [items, setItems] = useState<PuzzleDragObject[]>(arrayShuffle([0, 1, 2, 3, 4, 5, 6, 7, 8]).map((value, key) => {
        return {id: key, position: value}
    }))

    const dragEnd = (id, target_id) => {
        const sourceIndex = items.findIndex(item => item === id);
        const destinationIndex = items.findIndex(item => item === target_id);
        if (sourceIndex !== -1 && destinationIndex !== -1) {
            setItems([...move(items, sourceIndex, destinationIndex)])
        }
    }

    const move = (array, oldIndex, newIndex) => {
        const oldElement = array[oldIndex].position
        const newElement = array[newIndex].position
        array[oldIndex].position = newElement
        array[newIndex].position = oldElement
        return array;
    }

    useEffect(() => {
        setIsCompleted(
            items.map(item => item.position)
                .slice(1)
                .every((item, i) => items[i].position <= item)
        )
    }, [items])

    useEffect(() => {
        if (isCompleted) props.onComplete()
    }, [isCompleted, props])

    return <DndProvider backend={HTML5Backend}>
        <div className="puzzle-component">
            {items.map((item, index) => (
                <PuzzleDragItem key={item.id} id={item} position={props.solve ? index : item.position} onDragEnd={dragEnd} src={props.imageSource} disabled={isCompleted} />
            ))}
        </div>
    </DndProvider>
}
